<template>
  <div class="product-add pb50">
   <!--添加课程-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加课程</div>
      <el-form-item label="标题" prop="title"><el-input v-model="form.title" placeholder="请输入标题" class="max-w460"></el-input></el-form-item>
      <!-- <el-form-item label="描述" prop="dec"><el-input v-model="form.dec" placeholder="请输入文章描述" class="max-w460"></el-input></el-form-item> -->
      <el-form-item label="封面图">
        <div>
          <div class="img-item">
              <div class="addimg-select" @click="openUpload('img')" v-if="!form.image.file_path"><i class="el-icon-plus"></i></div>
              <el-image class="imgw100" v-else :src="form.image.file_path" fit="cover" alt="" :preview-src-list="[form.image.file_path]" />
              <a v-if="form.image.file_path" href="javascript:void(0);" class="delete-btn" @click.stop="delImg"><i class="el-icon-close"></i></a>
          </div>
          <p class="gray9">建议尺寸150x150px</p>

          <!--上传图片组件-->
          <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
        </div>
      </el-form-item>
      <el-form-item label="分类">
        <el-select v-model="form.category_id" placeholder="请选择">
          <el-option v-for="(item, index) in category" :key="index" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>
      <!--视频地址-->
      <el-form-item label="视频地址：">
        <el-input v-model="form.video_url" class="max-w460">
          <!-- <el-button slot="append" icon="el-icon-upload" @click="openUpload('video')">选择视频</el-button> -->
        </el-input>
      </el-form-item>
      <el-form-item label="虚拟阅读量"><el-input type="number" v-model="form.virtual_views" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <el-form-item label="是否收费">
         <el-radio-group v-model="form.is_money">
           <el-radio :label="0">免费</el-radio>
           <el-radio :label="1">收费</el-radio>
         </el-radio-group>
       </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="内容">
        <div class="edit_container">
          <Uediter v-model="form.content" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
        <p class="gray9">注：内容图片宽度自适应或拖动尺寸</p>
      </el-form-item>
      <el-form-item label="排序"><el-input type="number" v-model="form.sort" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import CourseApi from '@/api/study/course.js';
import CategoryApi from '@/api/study/category.js';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*编辑器*/
    Uediter,
    /*图片上传*/
    Upload: Upload
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      path: '',
      /*form表单数据*/
      form: {
        title: '',
        category_id: '',
        image_id: '',
        image:{file_path:''},
        video_url: '',
        is_money: 0,
        sort: 100,
        status: 1,
        virtual_views: 1,
        content: '',
      },
      /*文章类别*/
      category: [],
      loading: false,
      /*验证规则*/
      rules: {
        title: [{ required: true, message: '请输入文章标题', trigger: 'blur' }],
      },
      upload_type : 'img'
    };
  },
  created() {
    /*获取列表*/
    this.getCategoryList();
  },
  methods: {
    /*上传*/
    openUpload(e) {
      this.upload_type = e;
      this.isupload = true;
    },

    delImg(){
      this.form.image_id='';
      this.form.image.file_path='';
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null) {
        if (this.upload_type == 'img'){
          this.form.image_id = e[0].file_id;
          this.form.image.file_path = e[0].file_path;
        }else{
          this.form.video_url = e[0].file_path;
        }
      }
      this.isupload = false;
    },

    /*获取类别*/
    getCategoryList() {
      let self = this;
      let Params = {type:83};
      CategoryApi.getList(Params, true)
        .then(res => {
          self.category = res.data.list;
          if(self.category.length > 0){
            self.form.category_id = self.category[0].category_id;
          }
        })
        .catch(error => {});
    },

    /*添加文章*/
    onSubmit() {
      let self = this;
      let form = self.form;
      form.content = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CourseApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/study/course');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回文章列表*/
    cancelFunc() {
      this.$router.push({
        path: '/study/course'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/study/course/add.vue